<template>
	<div class="exercise analysis">
		<el-row :gutter="20">
			<el-col :span="24">
				<div class="card">
					<h5>Records</h5>
					<ActivityTable :event="event"></ActivityTable>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import ActivityAnalysis from '.'
import ActivityTable from './Table'

export default {
	extends: ActivityAnalysis,

	components: {
		ActivityTable
	}
}
</script>

<style lang="scss" scoped>
@import "../../../component/table/style/analysis.scss";
</style>
